<template>
	<Tippy
		:content="
			$t('chat_message_edited_date', { Date: $m(date + 'Z').format('l, LT') })
		"
		class="edited"
	>
		{{ $t('chat_message_edited') }}
	</Tippy>
</template>

<script>
import { Tippy } from '@/components/common'

export default {
	name: 'EditedFlag',
	components: { Tippy },
	props: ['date'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.edited {
	@include fontFamily(800);
	font-size: 12px;
	color: $neutral-300;
}
</style>
